import React, { useState, useEffect } from "react";
import { Checkbox, Descriptions } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import { useQuery } from "@tanstack/react-query";
import { DelphiDatumShow } from "../Helper/DateTimeHelper.jsx";
import { IntToBetrag } from "../Helper/ZahlenFormat.jsx";

export const AconkundenDetails = ({ aktRecnr, setTitel }) => {
  const [url1, setUrl1] = useState("");
  const { user, logoutLogin, apiBaseUrl } = LayoutData();
  const [dataSource, setDataSource] = useState();
  const [items, setItems] = useState();

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    // console.log("XXX ", apiBaseUrl, aktRecnr);
    if (apiBaseUrl && aktRecnr !== undefined && aktRecnr !== 0) {
      setUrl1(
        `${apiBaseUrl}api/evliveup?secure=1d7b2028-cee4-4589-8be0-fdd2d1cca996&Recnr=${aktRecnr}`
      );
    }
  }, [apiBaseUrl, aktRecnr]);

  const {
    isPending: isPending1,
    error: error1,
    data: aconkundenData,
  } = useQuery({
    queryKey: [url1],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) =>  {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return null;// Promise.resolve({});
      }
    },
  });
  if (error1) {
    console.log("url1", url1);
    console.error("XXX Error", error1);
    // logout();
  }

  useEffect(() => {
    if (aconkundenData) {
      setTitel(<>{aconkundenData.kundenname}</>);
    
      const itemsData = [];
      const add = (title, text) => {
        itemsData.push({
          label: <>{title}</>,
          children: <>{text}</>,
          key: itemsData.length,
        });
      };
      add("Name", aconkundenData.name);
      add("EMail", aconkundenData.email);
      add("Aktiv", <Checkbox checked={aconkundenData.aktiv} />);
      add("Kund.Nr.", aconkundenData.kdnr);
      add(<>Nickname</>, aconkundenData.nickname);
      add("Passwort", aconkundenData.passwort);
      add("Imendo Kunde", <Checkbox checked={aconkundenData.imendo} />);
      add("Updatepreis", <IntToBetrag zahl={aconkundenData.updatepreis} />);
      add("Sperre", <Checkbox checked={aconkundenData.sperre} />);
      add("PW-EMail OK", <Checkbox checked={aconkundenData.pwemailok} />);
      add(
        `Von Datum ${aconkundenData.vondatum}`,
        <DelphiDatumShow delphiDatum={aconkundenData.vondatum} />
      );
      add(
        "Bis Datum",
        <DelphiDatumShow delphiDatum={aconkundenData.bisdatum} />
      );
      add("PW Datum", <DelphiDatumShow delphiDatum={aconkundenData.pwdatum} />);
      add(
        "EMail Datum",
        <DelphiDatumShow delphiDatum={aconkundenData.emaildatum} />
      );
      add("Gratiskunde", <Checkbox checked={aconkundenData.gratiskunde} />);
      add("Wartungskunde", <Checkbox checked={aconkundenData.wartungskunde} />);
      add("EMail Anrede", aconkundenData.emailanrede);
      add("PLZ", aconkundenData.plz);
      add("ftp-Export OK", <Checkbox checked={aconkundenData.ftpexportok} />);
      add("Kein Infoemail", <Checkbox checked={aconkundenData.keininfomail} />);
      add("Email Vorlage", aconkundenData.emailvorlage);
      add("Last Infoemail", aconkundenData.infomaillastnr);
      add(
        "Info Email Datum",
        <DelphiDatumShow delphiDatum={aconkundenData.infomaildatum} />
      );
      add("Kein Angebot", <Checkbox checked={aconkundenData.keinangebot} />);
      add("UID Nummer", aconkundenData.uidnummer);
      add("Rechnung OK", <Checkbox checked={aconkundenData.rechnungok} />);

      setItems(itemsData);
      //checkMainContainerHeight();
      setDataSource(aconkundenData);
    }
  }, [aconkundenData]);

  return (
    <>
      <Descriptions
        //title="User Info"
        items={items}
        column={1}
        size="small"
        bordered={true}
        loading={isPending1.toString()}
        />

      {/* 
           "cdbestellt": 1,
            "cdgeduckt": 41621,
          "cdblsbestellt": 0,
           "cdblsgeduckt": 0, 
           "cdkochbuchbestellt": 0,
          "cdkochbuchgeduckt": 0, 
          "projektgruppe": "",
      */}
    </>
  );
};
